/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import {
  Divider as ChakraDivider,
  Stack,
  Text,
} from '@getgo/chameleon-chakra-ui';

interface Props {
  orientation?: 'vertical' | 'horizontal';
  conjunction?: string;
}

export const DividerWithText: React.FC<Props> = (props) => {
  const { conjunction, orientation } = props;

  if (conjunction) {
    return (
      <Stack
        fontSize='1.2rem'
        height='full'
        justifyContent='center'
        alignItems='center'
        color='#d0d2dd'
        py='2rem'
      >
        <ChakraDivider borderWidth='0.0625rem' orientation={orientation} />
        <Text>{conjunction}</Text>
        <ChakraDivider borderWidth='0.0625rem' orientation={orientation} />
      </Stack>
    );
  }
  return <ChakraDivider orientation={orientation} />;
};
